import { useNavigator } from '@repo/toolkit/use-navigator'
import Typography from '@repo/ui/typography'

import { Paths } from '../../../../lib/constants/path'
import { Ol } from '../../../../lib/types/models/ol/ol'
import { getOlName } from '../../../../views/ols/center/utils/functions'
import { constructOlPath } from '../../../../views/ols/views/utils'

type Props = {
  ol: Pick<Ol, 'id' | 'mainContactFirstName' | 'mainContactLastName'>
}

const OlNameNavigatorLink = ({ ol }: Props) => {
  const { navigate } = useNavigator()
  return (
    <Typography.Link
      variant="label-medium"
      onClick={(e) => {
        e.stopPropagation()
        navigate(constructOlPath(Paths.OL_DETAILS_UPDATE_PAGE, ol.id), {
          state: { from: Paths.OL_HOST_FAMILY_GLOBAL_LIST_PAGE }
        })
      }}
    >
      {getOlName(ol)}
    </Typography.Link>
  )
}

export default OlNameNavigatorLink
